import WidgetSkeleton from "@/components/ui/widgetSkeleton";
import React from "react";

const NewQuickViewLoadingState: React.FC = () => {
  return (
    <div className="flex flex-col gap-4 p-5 w-full overflow-y-auto">
      <WidgetSkeleton className="h-32 w-full rounded-lg" />
      <WidgetSkeleton className="h-32 w-full rounded-lg" />
      <WidgetSkeleton className="h-48 w-full rounded-lg" />
      <WidgetSkeleton className="h-80 w-full rounded-lg" />
    </div>
  );
};

export default NewQuickViewLoadingState;
